import axios from 'axios';
import { getCookie, setCookie } from '@utils/utils';
import { auth_server,resource_server,otp_server } from "@utils/settings"


const sessionApi = axios.create({
  baseURL: resource_server,
  withCredentials: true,
  headers:{
    "Content-Type": "application/json"
  }
});

const authApi = axios.create({
  baseURL: auth_server,
  headers:{
    "Content-Type": "application/json"
  }
});
const chiusuraCassaApi = axios.create({
  baseURL: resource_server + '/chiusura_cassa',
})
const otpApi = axios.create({
    baseURL: otp_server,
    headers:{
      "Content-Type": "application/json"
    }
  });

const resourceApi = axios.create({
  baseURL: resource_server,
  withCredentials: true,
  headers:{
    "Content-Type": "application/json", 
  }
});

chiusuraCassaApi.interceptors.request.use((config)=>{
  if(import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`
  // let url = resource_server + '/chiusura_cassa/'+dayjs(startDate).format('YYYYMMDD')+ '/' + dayjs(endDate).format('YYYYMMDD')
  //                               fetch(url).then(res=>console.log(res.json()))
  return config; 
},
(error)=> Promise.reject(error)
)

authApi.interceptors.request.use(
    (config) => {
      // const token = getCookie('token');
      if (import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

otpApi.interceptors.request.use(
  (config) => {
          // const token = getCookie('token');
          //if (import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`;
          return config;
  },
  (error) => Promise.reject(error)
);
sessionApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error.response.data.error_message)
); 
otpApi.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    return Promise.reject(error.response.response.data.error_message);
  }
);
chiusuraCassaApi.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    return Promise.reject(error.response.response.data.error_message);
  }
);
authApi.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    return Promise.reject(error.response.response.data.error_message);
  }
);
resourceApi.interceptors.request.use(
    (config) => {
        const isDataEmpty = !config.data || 
        (Object.keys(config.data).length === 0 && config.data.constructor === Object);

      if (isDataEmpty) {
        // Rimuoviamo l'header sia dai default che dall'istanza specifica della richiesta
        delete config.headers['Content-Type'];
        
        // Opzionale: se hai impostato il default nell'istanza, pulisci anche quello
        if (config.defaults && config.defaults.headers && config.defaults.headers.post) {
           delete config.defaults.headers.post['Content-Type'];
        }
        
        // Importante: per evitare che Axios invii "{}" come stringa JSON, 
        // forziamo data a undefined se era un oggetto vuoto
        config.data = undefined;
      }
      // const token = getCookie('token');
      //if (import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`;

        config.url = `/api${config.url}`;
      return config;
    },
    (error) => Promise.reject(error)
  );
resourceApi.interceptors.response.use(
  
    (response) => response.data,
    async (error) => {
      return Promise.reject(error.response.data.error_message);
    }
  );
export { authApi, resourceApi,otpApi,chiusuraCassaApi,sessionApi };